import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UsersTableService } from "src/app/services/crud-table/tables/buyer/users-table.component";
import { ADDRESS_MODAL_STYLE, ADDRESS_TABLE_COLUMN_WIDTH, INVITE_MODAL_STYLE, REGEX } from "../../../constants";

@Component( {
	selector: "app-users-deprecated",
	templateUrl: "./users.component.html",
	styleUrls: [ "./users.component.scss" ]
} )

export class UsersComponent extends UsersTableService implements OnInit, OnDestroy {

	listOfCurrentPageData: Array<object> = [];
	checked: boolean = false;
	setOfCheckedId = new Set<number>();
	indeterminate = false;
	columnWidth = ADDRESS_TABLE_COLUMN_WIDTH.INDEX;
	selectedValue: string = "Administrator";
	inviteModalVisible: boolean = false;
	inviteUserForm: FormGroup;
	formModalStyle: object = ADDRESS_MODAL_STYLE;
	SelectedRole: string = "";
	inviteModalStyle: object = INVITE_MODAL_STYLE;

	constructor(
		private formBuilder: FormBuilder,
		@Inject( HttpClient ) http
	) {
		super( http );
	}

	ngOnInit() {
		this.inviteUserForm = this.formBuilder.group( {
			email: [ "", [ Validators.required ] ],
			role: [ "", [ Validators.required ] ]
		} );

		this.inviteUserForm.valueChanges.subscribe( ( value ) => {
			const lettersOnlyRegex = REGEX.ONLY_LETTERS;
			const passwordRegex = REGEX.PASSWORD;
			const emailRegex = REGEX.EMAIL;

			if ( value.email && value.email.endsWith( "@" ) ) {
				this.inviteUserForm.controls["email"].setErrors( { "incompleteEmail": true } );
			} else if ( value.email && !value.email.match( emailRegex ) ) {
				this.inviteUserForm.controls["email"].setErrors( { "invalidEmail": true } );
			}
		} );
	}

	listOfOption = [
		{
			label: "Administrator",
			value: "Administrator"
		},
		{
			label: "Buyer",
			value: "Buyer"
		}
	];

	listOfData = [
		{
			id: 1,
			name: "David Muller",
			status: "active"
		},
		{
			id: 2,
			name: "Alice bob",
			status: "active"
		},
		{
			id: 3,
			name: "Bob Muller",
			status: "Inactive"
		}
	];

	listOfColumn = [
		{
			title: "User",
			compare: null,
			sortOrder: null,
			sortFn: ( a: object, b: object ) => a["name"].localeCompare( b["name"] ),
			sortDirections: [ "ascend", "descend", null ],
			width: ADDRESS_TABLE_COLUMN_WIDTH.ROLES
		},
		{
			title: "Status",
			compare: null,
			sortOrder: null,
			sortFn: ( a: object, b: object ) => a["status"].localeCompare( b["status"] ),
			sortDirections: [ "ascend", "descend", null ],
			width: ADDRESS_TABLE_COLUMN_WIDTH.ROLES
		},
		{
			title: "Role",
			width: ADDRESS_TABLE_COLUMN_WIDTH.ACTION
		}
	];

	listOfOptions = [
		{
			id: 1,
			role: "Administrator"
		},
		{
			id: 2,
			role: "Buyer Admin"
		},
		{
			id: 3,
			role: "Buyer"
		},
		{
			id: 4,
			role: "Supplier Admin"
		},
		{
			id: 5,
			role: "Supplier"
		}
	]

	/**
	 * Handle all row selection
	 * @param value : boolean value to check mark all rows
	 */
	onAllChecked( value: boolean ): void {
		const data = this.grouping.selectAllRows();
		this.setOfCheckedId = data.selectedRowIds;
		this.refreshCheckedStatus();
	}

	/**
	 * Handle set check status
	 * @param id : unique key of data set
	 * @param checked: value for updating set
	 */
	updateCheckedSet( id: number, checked: boolean ): void {
		this.grouping.selectRow( id );
		this.refreshCheckedStatus();
	}

	/**
	 * Handle refresh checked status.
	 */
	refreshCheckedStatus(): void {
		this.checked = this.grouping.checkAreAllRowsSelected();
		const allUnchecked = this.grouping.getSelectedRowsCount();
		if ( allUnchecked === 0 ) {
			this.checked = false;
			this.setOfCheckedId = new Set<number>();
		}
		this.indeterminate = this.grouping.getSelectedRowsCount() > 0 && !this.checked;
	}

	/**
	 * Handle current page change event.
	 * @param $event : change event
	 */
	onCurrentPageDataChange( $event ): void {
		this.listOfCurrentPageData = $event;
		this.refreshCheckedStatus();
	}

	/**
	 * Handle each row selection
	 * @param id : unique key of data set
	 * @param checked: checked value (true/false)
	 */
	onItemChecked( id: number, checked: boolean ): void {
		this.updateCheckedSet( id, checked );
		this.refreshCheckedStatus();
	}

	/**
	 * Handle role selection
	 */
	valueSelected( data, user ): void {
	}

	/**
	 * Handle user invite form submission.
	 * @param formValues : values of all fields of user invite form
	 */
	handleOk( formValues: object ): void {
		this.inviteModalVisible = false;
		this.inviteUserForm.reset();
	}

	/**
	 * Handle user invite form close.
	 */
	handleCancel( formValues: object ): void {
		this.inviteModalVisible = false;
		this.inviteUserForm.reset();
	}

	/**
	 * Display invite user modal
	 */
	showInviteModal(): void {
		this.inviteModalVisible = true;
	}

	onChange( searchKeyword: string ): void {
		const dataObject = {
			searchTerm: searchKeyword
		};

		this.findUsers( dataObject ).subscribe( response => {
			//console.log( "users", response );
		} );
	}

	/**
	 * Delete all selected users
	 */
	deleteAllSelectedUsers(): void {
		const selectedItemIds = this.grouping.getSelectedRows();
		// const sb = this.deleteUsers(selectedItemIds).subscribe();
		// this.subscriptions.push(sb);
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach( sb => sb.unsubscribe() );
	}
}
